// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessageSearch(event, iframeId) {
  try {
    let dataObj = JSON.parse(event.data);

    if (dataObj.action === 'search') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          eventData: dataObj,
        }),
        '*'
      );
    }
    if (dataObj && dataObj.eventType === 'listenerAttached') {
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    }
  } catch (error) {}
}
class GevmeSearch extends HTMLElement {
  constructor() {
    super();
  }
  attachSearchMessageEvent(iframeId) {
    window.addEventListener('message', (e) => {
      if (isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
        handleMessageSearch(e, iframeId);
      }
    });
  }
  connectedCallback() {
    var iframe = document.createElement('iframe'),
      redirectBaseURI = `${
        window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
      }/widgets`,
      objset = {},
      iframeSrc = '',
      isContentBlock = false,
      frameHeight = '200px',
      settings = this.getAttribute('settings'),
      preview = this.getAttribute('preview'),
      fullpagepreview = this.getAttribute('fullpagepreview'),
      slug = this.getAttribute('slug'),
      identifier = Date.now(),
      iframeId = `GevmeSearch${identifier}`;
    try {
      // if JSON.parse fails then settings is a string not an object
      // in this case use the old format
      objset = JSON.parse(settings);
      iframeSrc =
        redirectBaseURI + '/search?s=' + encodeURI(JSON.stringify(objset));
      frameHeight = objset && objset.height ? objset.height : '200px';
    } catch (error) {
      // in this case blockid was passed in settings attribute
      isContentBlock = true;
    }

    if (isContentBlock) {
      try {
        const passedId = settings;
        const showcaseBlocks = Object.values(
          window.GEVME.livepage.showcaseblocks
        );
        const searchData = showcaseBlocks.find(({ id }) => id === passedId);
        if (!searchData) throw new Error('block not found');

        if (searchData.blockHeight && searchData.blockHeight !== 'fit-content')
          frameHeight = searchData.blockHeight;

        iframeSrc =
          `${redirectBaseURI}/search?frameId=${iframeId}&companyId=${window?.GEVME?.project?.companyId}&projectId=${window?.GEVME?.project?.id}&livePageId=${window?.GEVME?.livepage?.id}&blockId=${passedId}` +
          `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}` +
          `${identifier ? `&id=${identifier}` : ''}` +
          (fullpagepreview
            ? `&previewInXP=${
                fullpagepreview === 'true' || fullpagepreview === 'undefined'
                  ? 'false'
                  : 'true'
              }`
            : '') +
          `&slug=${window?.GEVME?.livepage?.slug}`;
      } catch (error) {
        console.error(error);
      }
    }
    iframe.id = iframeId;
    iframe.name = 'GevmeSearch';
    iframe.title = 'Gevme Search';
    iframe.sandbox =
      'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = 'lazy';
    iframe.frameBorder = '0';
    iframe.referrerPolicy = 'no-referrer';
    iframe.src = iframeSrc;
    iframe.onload = function () {
      this.contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    };
    iframe.style = `display: flex; width: ${
      objset && objset.width ? objset.width : '100%'
    }; height: 100%; overflow: hidden; margin: auto;`;
    this.attachSearchMessageEvent(iframeId);
    this.append(iframe);
  }
}
window.customElements.define('gevme-search', GevmeSearch);
